import React from 'react';
import { HtmlEditorInputRecord } from 'types/dynamic-forms/records/HtmlEditorInputRecord';
import usePropertyPath from '../hooks/usePropertyPath';
import useProperty from '../hooks/useProperty';
import WizardHTMLEditor from 'components/v2/epd-wizard-inputs/WizardHTMLEditor';

const HtmlEditorInputRenderer: React.FC<HtmlEditorInputRecord> = ({ propertyId, label, tooltip, helpText }) => {
  const propertyPath = usePropertyPath(propertyId);
  const { value, setValue, isVisible, isDisabled, errorMessage } = useProperty<string>(propertyPath);
  if (!isVisible) {
    return null;
  }

  return (
    <WizardHTMLEditor
      name={propertyId}
      label={label}
      tooltip={tooltip}
      helpText={helpText}
      error={errorMessage}
      value={value}
      onChanged={(_: string, newValue: string) => setValue(newValue)}
      placeholder="Type here"
      stripPastedStyles={true}
      disabled={isDisabled}
    />
  );
};

export default HtmlEditorInputRenderer;
